import { Parser } from "json2csv";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import formatSubscriber from "../../../utils/format-sub";
import SubscriberList from "../membership-list/membership-list";

const SubscriberListController = async ({ req, res, load, locals, api }) => {
  const { query } = req;

  let page = -1;
  if (typeof query.page !== "undefined") {
    page = query.page;
  }

  const allSubs = locals.activeUser.organizationId
    ? await load("subscribersListExport", {
        organizationUser: locals.activeUserToRequest._id,
      })
    : await load("subscribersListExport", {});

  const formattedSubs = allSubs.subscriptions.data.map(formatSubscriber);
  const fields = [
    "customer_name",
    "customer_email",
    "plan.interval",
    "created",
    "tenure",
    "current_period_start",
    "lastPayment",
    "lifetimeRevenue",
    "status",
    "paymentStatus",
  ];

  const json2csvParser = new Parser({ fields, unwind: ["plan"] });
  const csv = json2csvParser.parse(formattedSubs);

  if (query.customer) {
    if (locals.activeUser.organizationId) {
      await load("subscriberInvoices", {
        customer: query.customer,
        product: "msb_subscription_plan",
        productType: "PUSH",
        organizationUser: locals.activeUserToRequest._id,
      });
    } else {
      await load("subscriberInvoices", {
        customer: query.customer,
        product: "msb_subscription_plan",
        productType: "PUSH",
      });
    }
  }

  const modal = query.modal || {};

  locals.modal = {
    "activity-feed": <ActivityDrawer />,
  }[modal.type];
  res.body = (
    <SubscriberList
      allSubs={allSubs}
      subscribers={formattedSubs}
      csvString={csv}
      page={page}
      productType="subscription"
      key="subscribers"
      api={api}
    />
  );
};

export default SubscriberListController;
